import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/console.css";
import "./styles/app.css";
import { App } from "./app/App";
import { startVitals } from "./perf/vitals";

async function boot() {
  // Mocks em chunk próprio: o build sem VITE_MOCKS=on não carrega uma linha do MSW.
  if (import.meta.env.VITE_MOCKS === "on") {
    const { startMocks } = await import("./mocks/browser");
    await startMocks();
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  void startVitals();
}

void boot();
